export default "__VITE_ASSET__CE1FFsfz__"